import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import Logo from '../assets/images/logo.png'
import Notification from '../assets/images/notification.svg'
import Dot from '../assets/images/dot.svg'
import ThemeToggle from './ThemeToggle'
import { useDispatch, useSelector } from 'react-redux'
import CustomModal from './CustomModal'
import CustomTextFeild from '../common/CustomTextFeild'
import { _apiUrls } from '../utils/endpoints/apiUrls'
import { apiRequest } from '../utils/config/apiRequest';
import { showMessage } from '../utils/helpers/toastHelpers'
import { removeAuthCookie } from '../utils/helpers/authHelpers'
import { setAuth } from '../redux/slicers/auth'
import { Box } from '@mui/material'
import { validateChangePassword } from './Validation'
import { _toastVariants } from '../utils/constants/constants'
import { getTheme } from '../redux/selectors/appSelectors'
import WhiteLogo from '../assets/images/Wh.png'
import Menu from '../assets/images/menu-left-alt.svg';

export default function Header({ isMobile = false, onMenuClick = () => { } }) {

    const theme = useSelector(getTheme);
    const isDarkMode = theme === 'dark';

    const dispatch = useDispatch()
    const user = useSelector((state) => state.user);

    const [changePassword, setChangePassword] = useState(false);
    const [show, setShow] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setShow(false);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, []);


    // Update Password -----------------------------------

    const [load, setLoad] = useState(false)
    const [passwordState, setPasswordState] = useState({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [passwordErrors, setPasswordErrors] = useState({});

    const handleChangePassword = async () => {
        const errors = validateChangePassword(passwordState);
        setPasswordErrors(errors);

        if (Object.keys(errors).length > 0) return;

        const payload = {
            oldPassword: passwordState.oldPassword,
            newPassword: passwordState.newPassword,
        };

        setLoad(true);
        const { status } = await apiRequest({
            endUrl: _apiUrls.changePassword,
            method: 'PUT',
            body: payload,
            showMsg: true
        });

        setLoad(false);
        if (status) {
            setChangePassword(false);
            setPasswordState({ oldPassword: '', newPassword: '', confirmPassword: '' });
        }
    };

    const handleLogout = () => {
        dispatch(setAuth({ token: '', isAuth: false, userType: '' }));
        removeAuthCookie();
        showMessage({ variant: _toastVariants.Success, message: "Logout Successfully" })
    };

    return (
        <>
            <Box className="header-container px-0" style={{
                position: 'sticky', top: 0, paddingTop: "33px", zIndex: 1,
            }}>
                <Row className="align-items-center">
                    <Col md={4} xs={2}>
                        {isMobile && (
                            <button
                                onClick={onMenuClick}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    fontSize: '24px',
                                    marginRight: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <img src={Menu} alt="" className='white-icon' />
                            </button>
                        )}
                        <img src={isDarkMode ? WhiteLogo : Logo} alt="" className='darkmode-logo' />
                    </Col>

                    <Col md={8} xs={10} className='d-flex justify-content-end align-items-center'>
                        <div className="d-flex align-items-center gap-3">
                            <ThemeToggle />
                            {/* <div className="notify-circle">
                                <img src={Notification} alt="" className='notifyimg' />
                                <span className="notification-badge"></span> 
                            </div> */}
                            <div className="d-flex align-items-center gap-2" style={{ cursor: 'pointer' }}>
                                <div className="text-end">
                                    <p className='user-name mb-0'>{user?.fullName}</p>
                                    <p className='mb-0 mt-0 usertype'>{user.userType}</p>
                                </div>
                                {/* {user?.profilePic ? (
                                    <>
                                        {(() => {
                                            const fullImageUrl = `${process.env.REACT_APP_API_BASE_URL?.replace('/api', '')}${user?.profilePic?.startsWith('/') ? '' : '/'}${user?.profilePic}`
                                            return (
                                                <img
                                                    src={fullImageUrl}
                                                    alt=""
                                                    style={{ width: 40, height: 40, borderRadius: '50%' }}
                                                />
                                            );
                                        })()}
                                    </>
                                ) : (
                                    <div className="user-pic">
                                        <p className="mb-0">{(user?.fullName || 'NA').substring(0, 2).toUpperCase()}</p>
                                    </div>
                                )} */}
                                 <div className="user-pic">
                                        <p className="mb-0">{(user?.fullName || 'NA').substring(0, 2).toUpperCase()}</p>
                                    </div>
                            </div>
                            <div className="position-relative" ref={dropdownRef} style={{ display: 'inline-block', cursor: 'pointer' }}>
                                <img src={Dot} alt="" className='userprofile' onClick={() => setShow(!show)} />
                                {show && (
                                    <div className="dropdownmenu2 show p-3 shadow"
                                        style={{
                                            position: 'absolute',
                                            right: 0,
                                            top: '42px',
                                            backgroundColor: isDarkMode ? '#2d2e36' : '#fff',
                                            borderRadius: '8px',
                                            color: '#fff',
                                            width: '220px'
                                        }}>
                                        <div style={{
                                            position: 'absolute',
                                            top: '-10px',
                                            right: '15px',
                                            width: 0,
                                            height: 0,
                                            borderLeft: '8px solid transparent',
                                            borderRight: '8px solid transparent',
                                            borderBottom: isDarkMode ? '10px solid #2d2e36' : '10px solid #fff'
                                        }}></div>

                                        <div className="d-flex align-items-center pro-box"
                                            onClick={() => setChangePassword(true)}
                                            style={{ borderBottom: isDarkMode ? "1px solid #fff" : "1px solid #000", cursor: 'pointer' }}>
                                            <i class="fa fa-lock lockicon"></i>
                                            <p className='chagepassword mb-0'>Change Password</p>
                                        </div>

                                        <div className="d-flex align-items-center pro-box" onClick={handleLogout} style={{ borderBottom: isDarkMode ? "1px solid #fff" : "1px solid #000", cursor: 'pointer' }}>
                                            <i class="fa fa-sign-out lockicon"></i>
                                            <p className='chagepassword mb-0'>Logout</p>
                                        </div>
                                    </div>
                                )}
                            </div>


                        </div>
                    </Col>
                </Row>
            </Box>


            {/* Change Password ------------------------------------------------ */}

            <CustomModal
                show={changePassword}
                onHide={() => setChangePassword(false)}
                title="Change Password"
                subtitle="Fill the below fields"
                showCloseButton={true}
                footerButtons={
                    <>
                        <div style={{ display: 'flex', marginTop: 20, justifyContent: 'flex-start', gap: '10px', width: '100%' }}>
                            <Button variant="secondary"
                                style={{
                                    backgroundColor: "rgba(75, 128, 235, 1)",
                                    borderColor: "rgba(75, 128, 235, 1)",
                                    padding: "5px 20px"
                                }}
                                onClick={handleChangePassword}
                            >
                                Update Password
                            </Button>
                        </div>

                    </>
                }
            >

                <Row className='my-2'>
                    <Col md={12}>
                        <p className='mb-1 input-label f-14'>Old password</p>
                        <CustomTextFeild style={{
                            padding: "10px 13px",
                            borderRadius: "10px", height: "auto",
                            background: 'transparent'
                        }}
                            placeholder='Enter Old Password'
                            value={passwordState?.oldPassword}
                            onChange={(e) => setPasswordState({ ...passwordState, oldPassword: e.target.value })}
                        />
                        {passwordErrors.oldPassword && (
                            <small style={{ color: 'red' }}>{passwordErrors.oldPassword}</small>
                        )}
                    </Col>

                    <Col md={12} className='mt-3'>
                        <p className='mb-1 input-label f-14'>New password</p>
                        <CustomTextFeild style={{
                            padding: "10px 13px",
                            borderRadius: "10px", height: "auto",
                            background: 'transparent'
                        }}
                            placeholder='Enter New Password'
                            value={passwordState?.newPassword}
                            onChange={(e) => setPasswordState({ ...passwordState, newPassword: e.target.value })}
                        />
                        {passwordErrors.newPassword && (
                            <small style={{ color: 'red' }}>{passwordErrors.newPassword}</small>
                        )}

                    </Col>

                    <Col md={12} className='mt-3'>
                        <p className='mb-1 input-label f-14'>Re-type New password</p>
                        <CustomTextFeild style={{
                            padding: "10px 13px",
                            borderRadius: "10px", height: "auto",
                            background: 'transparent'
                        }}
                            placeholder='Enter Re-type New Password'
                            value={passwordState?.confirmPassword}
                            onChange={(e) => setPasswordState({ ...passwordState, confirmPassword: e.target.value })}
                        />
                        {passwordErrors.confirmPassword && (
                            <small style={{ color: 'red' }}>{passwordErrors.confirmPassword}</small>
                        )}
                    </Col>
                </Row>

            </CustomModal>


        </>
    )
}

